document.addEventListener('DOMContentLoaded', () => {
  const header = document.getElementById('site-header');
  if (!header) return;

  const showAt = 600;
  const isHome = window.location.pathname === '/';

  // ❌ Pas sur la home → header toujours visible
  if (!isHome) {
    header.classList.remove('is-hidden');
    return;
  }

  // ✅ Sur la home → logique de scroll
  function toggleHeader() {
    if (window.scrollY > showAt) {
      header.classList.remove('is-hidden');
    } else {
      header.classList.add('is-hidden');
    }
  }

  window.addEventListener('scroll', toggleHeader, { passive: true });

  // Vérifie aussi au chargement (refresh / ancre)
  toggleHeader();
});
